var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Ingest Settings")]),
      _c(
        "md-layout",
        [
          _c(
            "md-switch",
            {
              staticClass: "md-primary",
              model: {
                value: _vm.entity.useStitchCDN,
                callback: function($$v) {
                  _vm.$set(_vm.entity, "useStitchCDN", $$v)
                },
                expression: "entity.useStitchCDN"
              }
            },
            [_vm._v("Use Rhebus CDN to serve this content")]
          )
        ],
        1
      ),
      _c(
        "md-layout",
        [
          _c(
            "md-switch",
            {
              staticClass: "md-primary",
              model: {
                value: _vm.entity.transcodeSourceFiles,
                callback: function($$v) {
                  _vm.$set(_vm.entity, "transcodeSourceFiles", $$v)
                },
                expression: "entity.transcodeSourceFiles"
              }
            },
            [_vm._v("Transcode the videos in my feed")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc9ad7d6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc9ad7d6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/IngestSettingsForm.vue
// module id = 983
// module chunks = 0